exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-title .decoration[data-v-30aea63e]{background:var(--categoryTitleBg) 0 0 no-repeat;background-size:100% 100%}.category-title .decoration~span[data-v-30aea63e]{letter-spacing:.14em}", ""]);

// exports
